import type React from 'react';

import type { NormalizedBarChartData } from 'components/partials/charts/shared/types';
import { formatValue } from 'components/partials/charts/shared/format-value';
import { twMerge } from 'tailwind-merge';

import { AI_ASSISTANT_TABLE_CLASSES } from 'containers/admin/clients/client/tabs-components/ai-assistant/ai-assistant.constants';

interface ChartPartTableProps {
  data: NormalizedBarChartData;
  caption: string;
}

const ChartPartTable = ({
  data,
  caption,
}: ChartPartTableProps): React.JSX.Element => (
  <div className={twMerge(AI_ASSISTANT_TABLE_CLASSES.wrapper, 'mt-3')}>
    <table className={AI_ASSISTANT_TABLE_CLASSES.table}>
      <caption className="sr-only">{caption}</caption>
      <thead>
        <tr>
          <th scope="col" className={AI_ASSISTANT_TABLE_CLASSES.th}>
            {data.categoryAxis.label || 'Category'}
          </th>
          {data.series.map((singleSeries, index) => (
            <th
              key={`${singleSeries.label}-${index}`}
              scope="col"
              className={AI_ASSISTANT_TABLE_CLASSES.th}
            >
              {singleSeries.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.categoryAxis.categories.map((category, categoryIndex) => (
          <tr key={`${category}-${categoryIndex}`}>
            <th scope="row" className={AI_ASSISTANT_TABLE_CLASSES.td}>
              {category}
            </th>
            {data.series.map((singleSeries, seriesIndex) => (
              <td
                key={`${singleSeries.label}-${seriesIndex}-${categoryIndex}`}
                className={AI_ASSISTANT_TABLE_CLASSES.td}
              >
                {formatValue(singleSeries.values[categoryIndex], data.format)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ChartPartTable;
